import React from 'react';
import { useGlobal } from 'reactn';
import { formatCurrencyNum, formatLongDate } from '../../../helpers';
import Card from '../../common/card/Card';
import NeedHelp from '../../common/NeedHelp';

const AccountSummary = ({ ...rest }) => {
  const [serviceAccounts] = useGlobal('serviceAccounts');
  const [selectedServiceAccountIndex] = useGlobal(
    'selectedServiceAccountIndex'
  );
  const selectedServiceAccount = serviceAccounts[selectedServiceAccountIndex];

  if (selectedServiceAccount === undefined) {
    return <h4>SERVICE ACCOUNT UNAVAILABLE</h4>;
  }
  const {
    latestBillDate,
    latestBillAmount,
    lateChargesAmount,
    paymentsAmount,
    adjustmentsAmount,
    accountBalance,
    latestBillUrl,
  } = selectedServiceAccount.summaryData.data;

  return (
    <Card title="Account Summary" bodyClassName="justify-between" {...rest}>
      <div>
        <div className="border-b border-blue-light py-2 flex justify-between items-center">
          <span>Bill Date</span>
          <span className="font-bold">{formatLongDate(latestBillDate)}</span>
        </div>
        <div className="border-b border-blue-light py-2 flex justify-between items-center">
          <span>Bill Amount</span>
          <span className="font-bold">
            {formatCurrencyNum(latestBillAmount)}
          </span>
        </div>
        <div className="border-b border-blue-light py-2 flex justify-between items-center">
          <span>Late Charges Amount</span>
          <span className="font-bold">
            {formatCurrencyNum(lateChargesAmount)}
          </span>
        </div>
        <div className="border-b border-blue-light py-2 flex justify-between items-center">
          <span>Payments Amount</span>
          <span className="font-bold">{formatCurrencyNum(paymentsAmount)}</span>
        </div>
        <div className="border-b border-blue-light py-2 flex justify-between items-center">
          <span>Adjustments Amount</span>
          <span className="font-bold">
            {formatCurrencyNum(adjustmentsAmount)}
          </span>
        </div>
        <div className="py-2 flex justify-between items-center">
          <span>Total Amount Due</span>
          <span className="text-3xl font-4xl font-bold text-blue-dark">
            {formatCurrencyNum(accountBalance)}
          </span>
        </div>
      </div>
      <NeedHelp />
    </Card>
  );
};

export default AccountSummary;
